export const MM_DD_YYYY = 'MM/DD/YYYY';
export const MM_DD_YY = 'MM/DD/YY';
export const DD_MM_YYYY = 'DD/MM/YYYY';
export const DD_MM_YY = 'DD/MM/YY';

export const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const weekends = ['Saturday', 'Sunday'];
export const fullWeek = [...weekdays, ...weekends];
